/** Prevent mouse wheel from incrementing/decrementing focused `type="number"` inputs. */
export function installDisableNumberInputWheel(): void {
  document.addEventListener(
    "wheel",
    (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.type === "number") {
        event.preventDefault();
      }
    },
    { passive: false, capture: true },
  );
}
